class FaqAccordionItem extends HTMLElement {
  constructor() {
    super();
    this.el = this.querySelector('details');
    this.summary = this.el.querySelector('summary');
    this.content = this.el.querySelector('.faq-accordion__answer');
    this.link = this.content.querySelector('a[href^="mailto:"]');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.duration = 300;
    this.oneOpen = true;

    const accordion = new AccordionGlobals();
    this.summary.addEventListener('click', (e) => accordion.onClick(e, this));

    const clickToCopySpan = document.createElement('div');
    const html = '<span class="tooltip__copied hidden">Copied</span><span class="tooltip__copy">Click to copy</span>';
    clickToCopySpan.classList.add('tooltip__wrapper');
    clickToCopySpan.innerHTML = html;
 
    if (this.link) {
      this.link?.appendChild(clickToCopySpan);
      this.link?.addEventListener('click', (e) => this.clickToCopy(e));
    }
  }

  clickToCopy(element) {
    element.preventDefault();
    const email = element.srcElement.childNodes[0].textContent;
    const copiedElem = element.srcElement.querySelector('.tooltip__copied');
    const copyElem = element.srcElement.querySelector('.tooltip__copy');
    navigator.clipboard.writeText(email).then(() => {
      copiedElem.classList.remove('hidden');
      copiedElem.classList.add('fadeIn');
      copyElem.classList.add('hidden');
      setTimeout(() => {
        copyElem.classList.remove('hidden');
        copiedElem.classList.add('hidden');
        copiedElem.classList.remove('fadeIn');
      }, 2000);
    })
  }
}

customElements.define('faq-accordion-item', FaqAccordionItem);
